import { defineMessages } from 'react-intl';

export default defineMessages({
  pageTitle: {
    id: 'features.credentialRecovery.pageTitle',
    defaultMessage: 'Recupero credenziali',
    description: 'Title of the credential recovery page',
  },
  pageSubtitle: {
    id: 'features.credentialRecovery.pageSubtitle',
    defaultMessage: 'Scegli la tipologia di credenziali che vuoi recuperare',
    description: 'Subtitle of the credential recovery page',
  },
  buttonCredentialRecovery: {
    id: 'features.credentialRecovery.buttonCredentialRecovery',
    defaultMessage: 'Conferma',
    description: 'Label of the credential recovery button',
  },
  backTo: {
    id: 'features.credentialRecovery.backTo',
    defaultMessage: 'Torna alla login',
    description: 'Disclaimer "back to login"',
  },
  labelRecoveryUsernameRadioButton: {
    id: 'features.credentialRecovery.labelRecoveryUsernameRadioButton',
    defaultMessage: 'Recupera Username',
    description: 'Label of recovery username radio button',
  },
  labelRecoveryPasswordRadioButton: {
    id: 'features.credentialRecovery.labelRecoveryPasswordRadioButton',
    defaultMessage: 'Recupera Password',
    description: 'Label of recovery password radio button',
  },
});
